import React from "react";
import { Text, View } from "react-native";
import { AppImages } from "../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import ImageComponent from "../ImageComponent";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { useLiveStream } from "../../context/LiveStreamContext";
import Avatar from "../choose-avatar-components/Avatar";

const StreamPlayersView = () => {
  const { audienceData } = useLiveStream();
  const deviceSize = useDeviceSize();

  const { eventDetails, participantDetails } = audienceData;

  const organizer =
    participantDetails.find(
      (participant) => participant.userID === eventDetails.organiserId
    ) || {};

  const challenger =
    participantDetails.find(
      (participant) => participant.userID !== eventDetails.organiserId
    ) || {};

  const isMobile =
    deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS;

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingHorizontal: isMobile ? 8 : 16,
        paddingVertical: isMobile ? 12 : 20,
        gap: isMobile ? 6 : 12,
        backgroundColor: "#1F2937",
      }}
    >
      {/* Organizer Section */}
      <View
        style={{
          flex: 1,
          alignItems: "center",
          gap: isMobile ? 4 : 8,
        }}
      >
        {/* Kaller Label */}
        <Text
          style={[
            isMobile
              ? AppFontStyle.BOLD_ANYBODY_12
              : AppFontStyle.BOLD_ANYBODY_14,
            {
              color: "#DC2626",
            },
          ]}
        >
          Kaller
        </Text>

        {/* Avatar */}
        <View
          style={{
            width: isMobile ? 40 : 60,
            height: isMobile ? 40 : 60,
            overflow: "hidden",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Avatar
            variant={isMobile ? "notificationSmallPlayer" : "player"}
            src={
              organizer.profilePicture === ""
                ? "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                : organizer.profilePicture
            }
          />
        </View>

        {/* Username */}
        <Text
          style={[
            isMobile
              ? AppFontStyle.BOLD_ANYBODY_10
              : AppFontStyle.BOLD_ANYBODY_12,
            { color: AppColors.white, textAlign: "center" },
          ]}
          numberOfLines={1}
        >
          {organizer.userID || "Unknown"}
        </Text>
      </View>

      {/* Game Section */}
      <View
        style={{
          alignItems: "center",
          flex: isMobile ? 0.6 : 0.8,
          justifyContent: "center",
          gap: isMobile ? 4 : 8,
        }}
      >
        {/* VS Logo */}
        <ImageComponent
          url={AppImages.icVsLogo}
          style={{
            width: isMobile ? 30 : 40,
            height: isMobile ? 60 : 80,
            resizeMode: "contain",
          }}
        />

        {/* Game Image */}
        <ImageComponent
          url={eventDetails.gameImage || ""}
          style={{
            height: isMobile ? 45 : 70,
            width: isMobile ? 45 : 70,
            borderRadius: 8,
            resizeMode: "cover",
          }}
        />

        {/* Game Title */}
        <Text
          style={[
            isMobile
              ? AppFontStyle.BOLD_ANYBODY_10
              : AppFontStyle.BOLD_ANYBODY_12,
            {
              textAlign: "center",
              color: AppColors.white,
              maxWidth: isMobile ? 80 : 100,
            },
          ]}
          numberOfLines={2}
        >
          {eventDetails.gameTitle || "Unknown Game"}
        </Text>
      </View>

      {/* Challenger Section */}
      <View
        style={{
          flex: 1,
          alignItems: "center",
          gap: isMobile ? 4 : 8,
        }}
      >
        {/* Opponent Label */}
        <Text
          style={[
            isMobile
              ? AppFontStyle.BOLD_ANYBODY_12
              : AppFontStyle.BOLD_ANYBODY_14,
            {
              color: "#DC2626",
            },
          ]}
        >
          Opponent
        </Text>

        {/* Avatar */}
        <View
          style={{
            width: isMobile ? 40 : 60,
            height: isMobile ? 40 : 60,
            overflow: "hidden",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Avatar
            variant={isMobile ? "notificationSmallPlayer" : "player"}
            src={
              challenger.profilePicture === ""
                ? "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                : challenger.profilePicture
            }
          />
        </View>

        {/* Username */}
        <Text
          style={[
            isMobile
              ? AppFontStyle.BOLD_ANYBODY_10
              : AppFontStyle.BOLD_ANYBODY_12,
            { color: AppColors.white, textAlign: "center" },
          ]}
          numberOfLines={1}
        >
          {challenger.userID || "Unknown"}
        </Text>
      </View>
    </View>
  );
};

export default StreamPlayersView;
